import * as HLF from "html-living-framework";
import * as SFX from "../../Data/SoundEffectKeys";
import { Lantern } from "../../GameObjects/Obstacles/Lantern";
import { Obstacle } from "../../GameObjects/Obstacles/Obstacle";
import { BoxCollider } from "../../Physics/BoxCollider";

export class LanternGroup extends Obstacle {
    private static readonly SPEED: number = -50;
    private static readonly Y_RANGE: PIXI.Point = new PIXI.Point(-350, 200);
    private static readonly SPACING: number = 100;

    private _lanterns: Lantern[];

    constructor() {
        super(LanternGroup.SPEED, new BoxCollider(0, 275, -40, 35));

        this.position.y = HLF.Random.floatBetweenPoint(LanternGroup.Y_RANGE);

        const indeces: number[] = [ 0, 1, 2 ];
        HLF.ArrayUtils.shuffle(indeces);
        this._lanterns = new Array<Lantern>(3);
        for (let i = 0; i < this._lanterns.length; ++i) {
            this._lanterns[i] = new Lantern(indeces[i]);
            this._lanterns[i].x = LanternGroup.SPACING * i;
            this.addChild(this._lanterns[i]);
        }
        this._collisionSfx = SFX.IMPACT_LANTERN;
    }
}
